import React, { ReactElement } from 'react';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import classnames from 'classnames';
import { Button } from '@mui/material';
import { useMediaQuery } from '@mui/material';
import useStyles from './useStyles';

export const RepliconProductBar = (props: {
  handleDrawerOpen: any;
  navigationMetadata: any;
}): ReactElement => {
  const theme = useTheme();
  const classes = useStyles();
  const pinMenu = 'PinMenu';
  const isPinned = pinMenu;
  const customLogoLink = isPinned ? false : true;

  const isSmallScreen = useMediaQuery('(max-width:900px)');

  return (
    <>
      <Box
        className="productBar"
        id="productBar"
        sx={{
          height: theme.spacing(8),
          minWidth: theme.spacing(30)
        }}
      >
        {customLogoLink ? (
          <Box
            sx={{
              height: theme.spacing(8),
              paddingTop: theme.spacing(1)
            }}
          >
            <Box
              className="customLogoExpanded"
              component="img"
              sx={{
                paddingTop: '20px',
                position: 'absolute',
                marginLeft: '12px',
                top: '0px',
                width: '148px',
                opacity: 0
              }}
            ></Box>
            <Box
              className="customLogoCollapsed"
              component="img"
              alt="custom logo"
              sx={{
                paddingTop: '14px',
                position: 'absolute',
                marginLeft: '4px',
                top: '0px',
                width: '60px',
                opacity: 1
              }}
            ></Box>
            {!isSmallScreen && (
              <Button
                className="iconButton pinButton"
                id="pinButton"
                onClick={props.handleDrawerOpen}
                aria-label="Pin Menu"
              >
                <svg
                  onClick={props.handleDrawerOpen}
                  className="svgIcon pinIcon"
                  focusable="false"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M 10.42471153846154,10.03984489160852 6.535576923076923,8.979184719828694 5.121346153846151,10.39339828220179 8.656923076923073,13.92893218813453 2.999999999999999,19.5857864376269 3.000000000000001,21 h 1.414230769230766 l 5.656923076923073,-5.65685424949238 3.53557692307693,3.53553390593274 1.41423076923076,-1.4142135623731 -1.06067307692308,-3.88908729652601 7.42471153846154,-5.303300858899102 -5.65692307692304,-5.65685424949238 z"></path>
                </svg>
              </Button>
            )}
          </Box>
        ) : (
          <Box>
            <svg
              className="repliconLogo"
              focusable="false"
              viewBox="0 0 55 64"
              aria-hidden="false"
              style={{
                height: '64px',
                verticalAlign: 'middle',
                marginTop: '-90px'
              }}
            >
              <path
                className="logoContainer"
                id="logoContainer"
                d="M 52,32 A 20,20 0 0 1 32,52 20,20 0 0 1 12,32 20,20 0 0 1 32,12 20,20 0 0 1 52,32 Z"
              ></path>
              <path
                className="letter letterR"
                style={{
                  transition: 'all 25ms',
                  transitionTimingFunction: ''
                }}
                d="m 33.580252,34.333322 c 3.821324,-0.799965 5.87274,-3.445053 5.87274,-7.433618 0,-4.827505 -3.34481,-7.759704 -8.517879,-7.759704 H 19 v 25.347291 h 5.312542 v -9.897568 h 3.447688 l 6.931973,9.897568 h 6.207221 z m -9.26771,-4.459628 V 25.20785 L 20.310029,23.897846 H 30.72603 c 2.207525,0 3.41442,1.276556 3.41442,3.001858 0,1.725329 -1.206895,2.97399 -3.41442,2.97399 z"
              ></path>
            </svg>
            <span
              className={classnames(
                classes.productbarFooterDeltekRepliconLogo,
                'deltekRepliconLogo'
              )}
            ></span>
            {!isSmallScreen && (
              <Button
                className="iconButton pinButton"
                id="pinButton"
                onClick={props.handleDrawerOpen}
                aria-label="Pin Menu"
                sx={{
                  padding: '12px',
                  minWidth: '48px',
                  width: '24px',
                  position: 'absolute',
                  marginLeft: '16px',
                  top: 0,
                  color: theme.palette.text.secondary,
                  borderRadius: '50%',
                  [theme.breakpoints.down('md')]: {
                    display: 'none'
                  }
                }}
              >
                <svg
                  onClick={props.handleDrawerOpen}
                  className="svgIcon pinIcon"
                  focusable="false"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                >
                  <path d="M 10.42471153846154,10.03984489160852 6.535576923076923,8.979184719828694 5.121346153846151,10.39339828220179 8.656923076923073,13.92893218813453 2.999999999999999,19.5857864376269 3.000000000000001,21 h 1.414230769230766 l 5.656923076923073,-5.65685424949238 3.53557692307693,3.53553390593274 1.41423076923076,-1.4142135623731 -1.06067307692308,-3.88908729652601 7.42471153846154,-5.303300858899102 -5.65692307692304,-5.65685424949238 z"></path>
                </svg>
              </Button>
            )}
          </Box>
        )}
      </Box>
    </>
  );
};
